// Adapt for me (#184): re-fit a mate's session to your kit, with the same
// swap step a live session uses for the equipment you don't have.
import llmApi from "../apis/llmApi";
import { getDefaultModel } from "../config/llmProviders";
import { applySubstitutions, buildSubstitutionPrompt, detectMismatches } from "./substituteExercises";

/** The profile's kit as a list (it's stored either way). */
export const equipmentList = (profile) => {
  const eq = profile?.availableEquipment;
  if (Array.isArray(eq)) return eq.filter(Boolean);
  return typeof eq === "string" ? eq.split(",").map((e) => e.trim()).filter(Boolean) : [];
};

/**
 * { plan, changes } with anything your kit can't do swapped. No kit set, or
 * nothing missing, returns the plan as it is with no changes.
 */
export async function adaptPlanToKit(plan, equipment) {
  if (!plan || !equipment?.length) return { plan, changes: [] };
  const mismatches = detectMismatches(plan, equipment);
  if (!mismatches.length) return { plan, changes: [] };
  const stored = JSON.parse(localStorage.getItem("llmSettings") || "{}");
  const provider = stored.provider || "google";
  const settings = {
    provider,
    model: stored.model || getDefaultModel(provider),
    apiKey: stored.apiKey || stored.apiKeys?.[provider] || "",
    apiKeys: stored.apiKeys || {},
  };
  const substitutions = await llmApi.generateExerciseSubstitutions(buildSubstitutionPrompt(mismatches, equipment), settings);
  return applySubstitutions(plan, substitutions);
}
